export default __webpack_public_path__ + "static/media/Quora.d3ba1574.svg";